// @flow
import React from 'react'
import * as url from 'url'

const SSOOrgError = (): any => {
  const siteUrl = window.location.href
  const parsedUrl = url.parse(siteUrl, true)
  const orgName = parsedUrl.query ? parsedUrl.query.org : ''
  const ssoLink = parsedUrl.query ? parsedUrl.query.ssolink : ''
  return (
    <div className='login'>
      <div className='login__header'>
        <i className='icon icon--logo' />
        <h3>Unauthorized</h3>
      </div>
      {parsedUrl && parsedUrl.host &&
        <h4>Direct login is not allowed for {orgName}. Please click <a href={ssoLink} className='SSO-link'>{parsedUrl.host + '/' + ssoLink}</a> for Single Sign On.</h4>}
    </div>
  )
}

export default SSOOrgError
